/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { DashboardPageSalesHourChart } from "bd-web-components"
import { hourShortForNewer } from "../../utils/dateFormat"

interface PageSalesByHourContainerProps {
  data: any
}

const PageSalesByHourContainer: React.FC<PageSalesByHourContainerProps> = ({ data }) => {
  let listLabelsSales: any = []
  let listDataOldSales: any = []

  const shortedSales = hourShortForNewer(data)

  if (shortedSales) {
    shortedSales.forEach((dataItem: any) => {
      if (dataItem.hora) {
        // Usa a hora diretamente como label (ex: "01:00", "02:00")
        listLabelsSales.push(dataItem.hora);
      }
      if (dataItem.label) {
        listLabelsSales.push(dataItem.label)
      }
      listDataOldSales.push([dataItem.quantidadeIngressosVendidos, dataItem.receita]);
    });
  }

  const pageSalesChart = {
    labels: listLabelsSales,
    chartData: {
      datasets: [
        {
          label: "Vendas antigas",
          data: listDataOldSales,
        },
      ],
    },
  }

  return (
    <DashboardPageSalesHourChart
      labels={pageSalesChart.labels}
      chartData={{
        datasets: [
          {
            label: pageSalesChart.chartData.datasets[0].label,
            data: pageSalesChart.chartData.datasets[0].data
          },
        ],
      }}
    />
  )
}

export default PageSalesByHourContainer
